import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Videosurveillance from './components/videosurveillance';
import skm from './components/skm';
import mom from './components/mom';
import designing from './components/designing';
import ScrollToTopRoute from './components/ScrollToTopRoute';
import Layout from './components/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';







function App() {
  return (
    <Layout>

      <HashRouter>

        <Route exact path='/' component={Home} />
        <ScrollToTopRoute exact path="/videosurveillance" component={Videosurveillance} />
        <ScrollToTopRoute exact path="/skm" component={skm} />
        <ScrollToTopRoute exact path="/mom" component={mom} />
        <ScrollToTopRoute exact path="/designing" component={designing} />
      </HashRouter>

    </Layout>
  );
}

export default App;
